export const setIsAuthenticated = (value: any) => ({
  type: 'SET_IS_AUTHENTICATED',
  value,
});

export const setPurposes = (value: any) => ({type: 'SET_PURPOSES', value});
export const addPurpose = (value: any) => ({type: 'ADD_PURPOSE', value});

export const setLoadingInfo = (value: any) => ({
  type: 'SET_LOADING_INFO',
  value,
});

export const setDigitalCommunications = (value: any) => ({
  type: 'SET_DIGITAL_COMMUNICATIONS',
  value,
});

export const setUser = (value: any) => ({type: 'SET_USER', value});
export const addToUser = (value: any) => ({type: 'ADD_TO_USER', value});
export const changeUserDOB = (value: any) => ({type: 'CHANGE_USER_DOB', value});

export const setWizard = (value: any) => ({type: 'SET_WIZARD', value});
export const addToWizard = (value: any) => ({type: 'ADD_TO_WIZARD', value});

export const setGlobalStyles = (value: any) => ({
  type: 'SET_GLOBAL_STYLES',
  value,
});
export const addToGlobalStyles = (value: any) => ({
  type: 'ADD_TO_GLOBAL_STYLES',
  value,
});
export const setSelectedBu = (value: any) => ({
  type: 'SET_SELECTED_BU',
  value,
});
export const setAvailableBus = (value: any) => ({
  type: 'SET_AVAILABLE_BUS',
  value,
});

export const setBusMap = (value: any) => ({
  type: 'SET_BUS_MAP',
  value,
});

export const setBusStylesMap = (value: any) => ({
  type: 'SET_BUS_STYLES_MAP',
  value,
});

export const setBusFuncMap = (value: any) => ({
  type: 'SET_BUS_FUNCTIONALITIES_MAP',
  value,
});

export const setBusFuncMapDefault = (value: any) => ({
  type: 'SET_BUS_FUNCTIONALITIES_MAP_DEFAULT',
  value,
});

export const setStrings = (value: any) => ({type: 'SET_STRINGS', value});

export const setStringsLoaded = (value: any) => ({
  type: 'SET_STRINGS_LOADED',
  value,
});

export const setIban = (value: any) => ({type: 'SET_IBAN', value});

export const setTitular = (value: any) => ({type: 'SET_TITULAR', value});

export const setStringsDefault = (value: any) => ({
  type: 'SET_STRINGS_DEFAULT',
  value,
});

export const setProducts = (value: any) => ({type: 'SET_PRODUCTS', value});

export const setCustomerCardModalTrigger = (value: any) => ({
  type: 'SET_CUSTOMER_CARD_MODAL_TRIGGER',
  value,
});

export const setIbanFilterOpenTrigger = (value: any) => ({
  type: 'SET_IBAN_FILTER_OPEN_TRIGGER',
  value,
});

export const setPatients = (value: any) => ({type: 'SET_PATIENTS', value});

export const setBusFuncionalities = (value: any) => {
  return {
    type: 'SET_BUS_FUNCIONALITIES',
    value,
  };
};
export const setBusStyles = (value: any) => ({
  type: 'SET_BUS_STYLES',
  value,
});
export const setBusProductExceptions = (value: any) => ({
  type: 'SET_BUS_PRODUCT_EXCEPTIONS',
  value,
});
export const setBusGroupExceptions = (value: any) => ({
  type: 'SET_BUS_GROUP_EXCEPTIONS',
  value,
});
export const setBuDefaultFunctionalities = (value: any) => ({
  type: 'SET_BU_DEFAULT_FUNCIONALITIES',
  value,
});
export const setBuDefaultStyles = (value: any) => ({
  type: 'SET_BU_DEFAULT_STYLES',
  value,
});

export const setSelectedBuReady = (value: any) => ({
  type: 'SET_SELECTED_BU_READY',
  value,
});

export const setConsultasOnlineEnabled = (value: any) => ({
  type: 'SET_CONSULTAS_ONLINE_ENABLED',
  value,
});
export const setMedicoOnlineEnabled = (value: any) => ({
  type: 'SET_MEDICO_ONLINE_ENABLED',
  value,
});
export const setIsLanguageSelected = (value: any) => ({
  type: 'SET_IS_LANGUAGE_SELECTED',
  value,
});
export const setLanguage = (value: any) => ({
  type: 'SET_LANGUAGE',
  value,
});
export const setLanguageOptions = (value: any) => ({
  type: 'SET_LANGUAGE_OPTIONS',
  value,
});

export const setCurrencies = (value: any) => ({
  type: 'SET_CURRENCIES',
  value,
});

export const setTenant = (value: any) => ({
  type: 'SET_TENANT',
  value,
});

export const setAccessToken = (value: any) => ({
  type: 'SET_ACCESS_TOKEN',
  value,
});

export const setShowPersonalDate = (value: any) => ({
  type: 'SET_SHOW_PERSONAL_DATE',
  value,
});

export const setBankAccountDataHolder = (value: any) => ({
  type: 'SET_BANK_ACCOUNT_DATA_HOLDER',
  value,
});

export const setUpdateRoutesNewSelectedPatient = () => ({
  type: 'SET_UPDATE_ROUTES_NEW_SELECTED_PATIENT',
});

export const setDisableReimbursementRequestButton = (value: any) => ({
  type: 'SET_DISABLE_REIMBURSEMENT_REQUEST_BUTTON',
  value,
});
export const setUserBankAccountDataWasUpdated = (value: any) => ({
  type: 'SET_USER_BANK_ACCOUNT_DATA_WAS_UPDATED',
  value,
});

export const setIsUnderMaintenance = (value: boolean) => ({
  type: 'SET_IS_UNDER_MAINTENANCE',
  value,
});

export const setIsUnderMaintenanceMessage = (value: string) => ({
  type: 'SET_IS_UNDER_MAINTENANCE_MESSAGE',
  value,
});

export const setBusFuncMapDefaultObject = (value: any) => ({
  type: 'SET_BUS_FUNC_MAP_DEFAULT_OBJECT',
  value,
});
